export function getTranslation() {
  try {
    const translationStr =
      localStorage.getItem("translation") ||
      localStorage.getItem("IP-translation");
    if (
      translationStr &&
      translationStr !== "null" &&
      translationStr !== "undefined"
    ) {
      const translation = JSON.parse(translationStr);
      // 注意：typeof null === 'object'，所以需要额外检查 translation !== null
      if (translation !== null && typeof translation === "object") {
        return translation;
      }
    }
  } catch (e) {
    console.warn("Failed to parse IP-translation from localStorage:", e);
  }
  // 返回空对象，在模板中使用 translation?.KEY || '.KEY' 格式访问
  // 不使用 Proxy 以确保 iPad Safari 兼容性
  return {};
}
